var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68,
    height: 40,
    viewBox: "0 0 68 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21_1754)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.3174 0.00404915C20.0218 -0.00246869 19.7218 -0.00246869 19.4218 0.00404915C8.83986 0.240864 0.239237 8.89873 0.00398746 19.5511C-0.24637 30.9334 9.00605 40.2474 20.3131 39.9954C26.831 39.8498 32.5957 36.5105 36.1202 31.4765C36.3273 31.1789 36.5281 30.8747 36.7201 30.5662C38.5568 27.6158 39.6489 24.1527 39.7309 20.4484C39.9748 9.36802 31.2123 0.247382 20.3174 0.00404915ZM19.3764 30.5532C13.9916 30.3033 9.63194 25.9146 9.3859 20.4961C9.10101 14.2803 14.188 9.16162 20.3628 9.44623C25.7476 9.69608 30.1073 14.0848 30.3533 19.5054C30.6382 25.7213 25.5512 30.84 19.3764 30.5554V30.5532Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8462 0.00434875V25.7955C53.8462 33.5669 47.5679 40 39.8457 40H36.6968V30.5643H39.8457C42.3989 30.5643 44.473 28.4743 44.473 25.9041V0.00434875H53.8462Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68 18.8713V40H58.6289V9.44H58.6311L68 18.8713Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1555 9.42046H58.6289V5.86606C59.6023 5.86606 60.4828 6.26582 61.1195 6.90674C61.7584 7.54983 62.1533 8.43843 62.1533 9.42046H62.1555Z",
    fill: "#48D6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0002 9.44001H65.0844C65.0844 7.64326 64.3614 6.01597 63.1895 4.83624C62.0219 3.66086 60.4075 2.93086 58.627 2.93086V0.00434875C61.2147 0.00434875 63.5586 1.06024 65.2528 2.76791C66.9492 4.47559 67.9981 6.83505 67.9981 9.44001H68.0002Z",
    fill: "#48D6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1555 9.42046H58.6289V5.86606C59.6023 5.86606 60.4828 6.26582 61.1195 6.90674C61.7584 7.54983 62.1533 8.43843 62.1533 9.42046H62.1555Z",
    fill: "#48D6C6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21_1754"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.decd3c76975d2645d6eaf2a173f0ec7d.svg";
export { ForwardRef as ReactComponent };